import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copy(event) {
    const value = event.currentTarget.dataset.mcpSetupCopyValue || "";
    if (!value) return;

    const done = () => this.flashCopied(event.currentTarget);

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(value)
        .then(done)
        .catch(() => this.fallbackCopy(value, done));
    } else {
      this.fallbackCopy(value, done);
    }
  }

  fallbackCopy(value, done) {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      done();
    } finally {
      document.body.removeChild(textarea);
    }
  }

  flashCopied(button) {
    const original = button.innerHTML;
    button.innerHTML = '<i class="icon check"></i> Copied';
    button.classList.add("green");
    setTimeout(() => {
      button.innerHTML = original;
      button.classList.remove("green");
    }, 1500);
  }
}
